import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = {
    key: 0,
    class: "d-sm-flex align-items-center"
};
const _hoisted_5 = { class: "me-3" };
const _hoisted_6 = { class: "form-label text-muted small mb-1" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { class: "d-flex align-items-center ms-15" };
const _hoisted_10 = { class: "form-label text-muted small mb-0 me-2" };
const _hoisted_11 = { value: "" };
const _hoisted_12 = { value: "pending" };
const _hoisted_13 = { value: "confirmed" };
const _hoisted_14 = { value: "preparing" };
const _hoisted_15 = { value: "ready" };
const _hoisted_16 = { value: "delivered" };
const _hoisted_17 = { value: "cancelled" };
const _hoisted_18 = {
    key: 0,
    value: "deleted"
};
const _hoisted_19 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_20 = { class: "table-responsive" };
const _hoisted_21 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_22 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_23 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_24 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_25 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_26 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_27 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_28 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_29 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_30 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_31 = { key: 0 };
const _hoisted_32 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_34 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_35 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_38 = {
    key: 0,
    class: "badge text-bg-secondary fs-13"
};
const _hoisted_39 = {
    key: 1,
    class: "badge text-bg-info fs-13"
};
const _hoisted_40 = {
    key: 2,
    class: "badge text-bg-success fs-13"
};
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_42 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_43 = {
    key: 0,
    class: "badge bg-black text-white px-2 py-1 fs-12 rounded"
};
const _hoisted_44 = {
    key: 1,
    class: "badge bg-orange text-white px-2 py-1 fs-12 rounded",
    style: { "background-color": "#f36d00 !important" }
};
const _hoisted_45 = {
    key: 2,
    class: "text-muted small"
};
const _hoisted_46 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_47 = {
    key: 0,
    class: "shadow-none lh-1 fw-medium text-black-emphasis"
};
const _hoisted_48 = {
    key: 1,
    class: "shadow-none lh-1 fw-medium text-black-emphasis"
};
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_50 = {
    key: 0,
    class: "badge text-bg-warning fs-13"
};
const _hoisted_51 = {
    key: 1,
    class: "badge text-bg-info fs-13"
};
const _hoisted_52 = {
    key: 2,
    class: "badge text-bg-primary fs-13"
};
const _hoisted_53 = {
    key: 3,
    class: "badge text-bg-success fs-13"
};
const _hoisted_54 = {
    key: 4,
    class: "badge text-bg-primary fs-13"
};
const _hoisted_55 = {
    key: 5,
    class: "badge text-bg-danger fs-13"
};
const _hoisted_56 = {
    key: 6,
    class: "badge text-bg-info fs-13"
};
const _hoisted_57 = {
    key: 7,
    class: "badge text-bg-warning fs-13"
};
const _hoisted_58 = {
    key: 8,
    class: "badge text-bg-secondary fs-13"
};
const _hoisted_59 = {
    key: 9,
    class: "badge text-bg-dark fs-13"
};
const _hoisted_60 = {
    key: 2,
    class: "shadow-none lh-1 fw-medium text-muted"
};
const _hoisted_61 = {
    key: 0,
    class: "badge text-outline-danger"
};
const _hoisted_62 = {
    key: 1,
    class: "badge text-outline-primary"
};
const _hoisted_63 = {
    key: 2,
    class: "badge text-outline-info"
};
const _hoisted_64 = {
    key: 3,
    class: "badge text-outline-muted"
};
const _hoisted_65 = {
    key: 4,
    class: "badge text-outline-warning"
};
const _hoisted_66 = {
    key: 0,
    class: "badge text-bg-secondary fs-13"
};
const _hoisted_67 = {
    key: 1,
    class: "badge text-black-emphasis fs-13"
};
const _hoisted_68 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_69 = { class: "dropdown" };
const _hoisted_70 = { class: "dropdown-menu" };
const _hoisted_71 = ["onClick"];
const _hoisted_72 = ["onClick"];
const _hoisted_73 = { key: 0 };
const _hoisted_74 = ["onClick"];
const _hoisted_75 = { key: 1 };
const _hoisted_76 = ["onClick"];
const _hoisted_77 = { key: 2 };
const _hoisted_78 = {
    class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center",
    style: { "max-width": "100%", "overflow-x": "auto" }
};
const _hoisted_79 = {
    class: "mb-0 text-paragraph",
    style: { "min-width": "100px", "text-align": "center" }
};
const _hoisted_80 = { class: "mt-15 mt-md-0" };
const _hoisted_81 = { class: "pagination mb-0" };
const _hoisted_82 = ["onClick"];
const _hoisted_83 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_85 = { class: "modal-content" };
const _hoisted_86 = { class: "modal-body text-center" };
const _hoisted_87 = {
    key: 0,
    class: "mb-3 fw-bold"
};
const _hoisted_88 = {
    key: 1,
    class: "mb-3 text-danger fw-bold"
};
const _hoisted_89 = {
    key: 2,
    class: "mt-3 text-start"
};
const _hoisted_90 = { class: "modal-footer" };
const _hoisted_91 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.userRole === 'ROLE_FRANCHISE')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('lists.restaurant')), 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedRestaurant,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                    options: _ctx.restaurantOptions,
                                    label: "name",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: _ctx.$t('lists.selectRestaurant'),
                                    class: "restaurant-select",
                                    onChange: _ctx.onRestaurantChange,
                                    onInput: _ctx.onRestaurantChange
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onChange", "onInput"])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('lists.searchOrder'),
                            onInput: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
                        }, null, 40, _hoisted_8), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('lists.status')), 1),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedStatus) = $event)),
                            class: "form-select form-select-sm shadow-none",
                            onChange: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.handleStatusChange && _ctx.handleStatusChange(...args))),
                            style: { "width": "150px" }
                        }, [
                            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('lists.allStatus')), 1),
                            _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('lists.pending')), 1),
                            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('lists.confirmed')), 1),
                            _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('lists.preparing')), 1),
                            _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('lists.ready')), 1),
                            _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('lists.delivered')), 1),
                            _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('lists.cancelled')), 1),
                            (_ctx.userRole === 'ROLE_FRANCHISE')
                                ? (_openBlock(), _createElementBlock("option", _hoisted_18, _toDisplayString(_ctx.$t('lists.deleted')), 1))
                                : _createCommentVNode("", true)
                        ], 544), [
                            [_vModelSelect, _ctx.selectedStatus]
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('lists.ref')), 1),
                                _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('lists.type')), 1),
                                _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('lists.client')), 1),
                                _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('lists.platform')), 1),
                                _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('lists.amount')), 1),
                                _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('lists.createdAt')), 1),
                                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('lists.orderStatus')), 1),
                                _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('lists.paymentStatus')), 1),
                                _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('lists.phoneNumber')), 1),
                                _cache[11] || (_cache[11] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                    _createElementVNode("td", _hoisted_32, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allOrder.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allOrder, (order) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: order.id
                                        }, [
                                            _createElementVNode("th", _hoisted_33, [
                                                _createElementVNode("div", _hoisted_34, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectionOrder(order)),
                                                            id: "step-order-ref"
                                                        }, _toDisplayString(_ctx.getOrderTransactionReference(order)), 9, _hoisted_36)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_37, [
                                                (order.order_type === 'click_collect')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('lists.takeaway')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.order_type === 'dine_in')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('lists.dineIn')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.order_type === 'delivery')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('lists.delivery')), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.getOrderCustomerName(order)), 1),
                                            _createElementVNode("td", _hoisted_42, [
                                                (order.platform === 'UBEREATS')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, [...(_cache[13] || (_cache[13] = [
                                                            _createElementVNode("i", { class: "flaticon-shopping-cart-2 me-1" }, null, -1),
                                                            _createTextVNode(" Uber Eats ", -1)
                                                        ]))]))
                                                    : (order.platform === 'JUSTEAT')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, [...(_cache[14] || (_cache[14] = [
                                                                _createElementVNode("i", { class: "flaticon-trolley-cart me-1" }, null, -1),
                                                                _createTextVNode(" Just Eat ", -1)
                                                            ]))]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(order.platform || 'WEB'), 1))
                                            ]),
                                            _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.getOrderTotal(order)) + " CHF ", 1),
                                            (_ctx.getOrderItems(order).length > 0)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_47, _toDisplayString(_ctx.formatDate(order.created_at, "dd/MM/yyyy HH:mm")), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_48, [...(_cache[15] || (_cache[15] = [
                                                        _createElementVNode("span", null, "-", -1)
                                                    ]))])),
                                            _createElementVNode("td", _hoisted_49, [
                                                (order.status === 'pending')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('lists.pending')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'confirmed')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.$t('lists.confirmed')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'preparing')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('lists.preparing')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'ready')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('lists.ready')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'delivered')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('lists.delivered')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'cancelled')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.$t('lists.cancelled')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'processing')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.$t('lists.processing')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'ready_for_delivery')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('lists.readyForDelivery')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'out_for_delivery')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.$t('lists.delivering')), 1))
                                                    : _createCommentVNode("", true),
                                                (order.status === 'deleted')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('lists.deleted')), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (_ctx.getOrderPayment(order))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                                                    (_ctx.getOrderPayment(order).status === 'pending')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('lists.awaitingPayment')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.getOrderPayment(order).status === 'paid' ||
                                                        _ctx.getOrderPayment(order).status === 'completed')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.$t('lists.paid')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.getOrderPayment(order).status === 'processing')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.$t('lists.processing')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.getOrderPayment(order).status === 'refunded')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('lists.refunded')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.getOrderPayment(order).status === 'cancelled' ||
                                                        _ctx.getOrderPayment(order).status === 'failed')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('lists.paymentCancelled')), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("td", null, [
                                                (_ctx.getOrderCustomerPhone(order) !== '-')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.getOrderCustomerPhone(order)), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_67, "-"))
                                            ]),
                                            _createElementVNode("td", _hoisted_68, [
                                                _createElementVNode("div", _hoisted_69, [
                                                    _cache[20] || (_cache[20] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_70, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.regeneratePdf(order))
                                                            }, [...(_cache[16] || (_cache[16] = [
                                                                    _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Régénérer PDF ", -1)
                                                                ]))], 8, _hoisted_71)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectionOrder(order))
                                                            }, [...(_cache[17] || (_cache[17] = [
                                                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Voir", -1)
                                                                ]))], 8, _hoisted_72)
                                                        ]),
                                                        (order.status !== 'deleted')
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                                                _createElementVNode("a", {
                                                                    class: "dropdown-item d-flex align-items-center",
                                                                    "data-bs-toggle": "modal",
                                                                    "data-bs-target": "#confirmModal",
                                                                    href: "javascript:void(0);",
                                                                    onClick: _withModifiers(($event) => (_ctx.selectForDelete(order, false)), ["stop"])
                                                                }, [...(_cache[18] || (_cache[18] = [
                                                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                        _createTextVNode(" Supprimer", -1)
                                                                    ]))], 8, _hoisted_74)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (order.status === 'deleted' && _ctx.userRole === 'ROLE_FRANCHISE')
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_75, [
                                                                _createElementVNode("a", {
                                                                    class: "dropdown-item d-flex align-items-center text-danger",
                                                                    "data-bs-toggle": "modal",
                                                                    "data-bs-target": "#confirmModal",
                                                                    href: "javascript:void(0);",
                                                                    onClick: _withModifiers(($event) => (_ctx.selectForDelete(order, true)), ["stop"])
                                                                }, [...(_cache[19] || (_cache[19] = [
                                                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                        _createTextVNode(" Supprimer définitivement", -1)
                                                                    ]))], 8, _hoisted_76)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_77, [
                                        _createVNode(_component_EmptyTable, {
                                            message: "Aucune commande pour le moment",
                                            colspan: 8,
                                            textClass: "text-muted"
                                        })
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_80, [
                        _createElementVNode("ul", _hoisted_81, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[21] || (_cache[21] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_82)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", {
                            class: "modal-title",
                            id: "confirmModalLabel"
                        }, " Confirmation de suppression "),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_86, [
                        _cache[24] || (_cache[24] = _createElementVNode("i", {
                            class: "fas fa-exclamation-triangle warning-icon text-warning mb-3",
                            style: { "font-size": "3rem" }
                        }, null, -1)),
                        (!_ctx.isPermanentDelete)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_87, " Êtes-vous sûr de vouloir supprimer cette commande ? "))
                            : (_openBlock(), _createElementBlock("p", _hoisted_88, " Attention : Cette action supprimera définitivement la commande de la base de données. Cette action est irréversible. ")),
                        (!_ctx.isPermanentDelete)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label small fw-medium" }, "Raison de la suppression (obligatoire)", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.deletionReason) = $event)),
                                    class: "form-control shadow-none",
                                    rows: "3",
                                    placeholder: "Ex: Erreur de saisie, client a annulé..."
                                }, null, 512), [
                                    [_vModelText, _ctx.deletionReason]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                        _cache[26] || (_cache[26] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            "data-bs-dismiss": "modal"
                        }, [
                            _createElementVNode("i", { class: "fas fa-times me-2" }),
                            _createTextVNode("Annuler ")
                        ], -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(_ctx.isPermanentDelete ? 'btn btn-danger' : 'btn btn-warning'),
                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.confirmationDeleteAction(_ctx.orderSelected))),
                            disabled: !_ctx.isPermanentDelete && !_ctx.deletionReason.trim(),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.isPermanentDelete ? 'Supprimer définitivement' : 'Supprimer'), 1)
                        ], 10, _hoisted_91)
                    ])
                ])
            ])
        ])
    ], 64));
}
